import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "icon", "as"];
import React from 'react';
import styled from 'styled-components';
import TooltipButton from 'components/TooltipButton';
import Icon from 'components/Icon';
import Text from 'components/Text';
import { pxToRem } from 'utils/ui/units';
var StyledButton = styled(TooltipButton).withConfig({
  displayName: "StackedButton__StyledButton",
  componentId: "sc-bcnwht-0"
})(["padding-left:0;padding-right:0;border-radius:", ";"], function (p) {
  return pxToRem(Math.min(p.theme.globals.borderRadius.buttons, 10));
});
function StackedButton(_ref) {
  var children = _ref.children,
    icon = _ref.icon,
    as = _ref.as,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledButton, _extends({
    variant: "transparent",
    forwardedAs: as
  }, otherProps), /*#__PURE__*/React.createElement(Icon, {
    name: icon,
    scale: 1.5,
    vAlign: true
  }), /*#__PURE__*/React.createElement(Text, {
    size: "xxs",
    display: "block",
    align: "center",
    lineHeight: 1.3
  }, children));
}
export default StackedButton;